import { useState, useEffect, useContext } from "react";
import { Stack, StackItem } from "@fluentui/react";
import { Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, Subtitle2Stronger, Input, Tooltip, ProgressBar, MenuItem } from "@fluentui/react-components";
import { Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, Dismiss16Regular, FilterAdd20Filled, Info16Filled, CheckboxCheckedSync20Regular, BookTemplate20Regular, UninstallApp20Regular, BoxCheckmark20Regular, SquareHintApps20Regular } from "@fluentui/react-icons";
import { CSVLink } from 'react-csv';
import { useNavigate } from "react-router-dom";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { ToastComponent } from "../../../components/toast/toast.component";
import { primaryIcon, secondaryIcon, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, dashboardTheme, BreadcrumbsBorder, lightTheme } from "../../../styles/customStyles";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { GlobalContext } from "../../../hooks/globalContext";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { SkeletonOverlayDataTable } from "../../../components/skeleton/skeletonOverlayDataTable";
import { Status_func } from "../../../api/troubleshoot/status_func";
import { ManageAppPages } from "../../../components/side_menu/InlineSidenav";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";

interface AuditData {
  JobCreatedTime: number;
  SelectionType: string;
  AgentName: string;
  AgentUniqId: string;
  automationName: string;
  createdBy: string;
  category: string;
  description: string;
  automation_sequence: string;
}

interface AutomationJSONData {
  id: number;
  dartid: number;
  automationName: string;
  jsonvalue: string;
}

export const AppStatus = () => {
  const handle = useFullScreenHandle();
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); 
  const { permissions } = usePermissionStore();
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportStatusData, setExportStatusData] = useState([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [final_data2, set_final_data2]: any = useState(null);
  const [selectedActivity, setselectedActivity] = useState({ name: '', time: '', initiated: '', IDX: '' });
  const [automationName, setAutomationName] = useState('');
  const [createdBy, setCreatedBy] = useState('');
  const [jsonValue, setJsonValue]: any = useState(null);
  const [automationJsonAuditData, setAutomationJsonAuditData] = useState<AuditData[]>([]);
  const [automationJsonData, setAutomationJsonData] = useState<AutomationJSONData[]>([]);
  const [automationIds, setAutomationIds] = useState<any[]>([]);
  const [final_Targetdata, set_final_Targetdata]: any = useState(null);
  const [tableData1, setTableData1] = useState([]);
  const [searchTargetVal, setSearchTargetVal] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingTable, setLoadingTable] = useState(true);
  const [jsonSchemaPkg, setJsonDataPkg]: any = useState({});
  const [uiSchemaPkg, setUiDataPkg]: any = useState({});
  const [jsonSchemaApp, setJsonDataApp]: any = useState({});
  const [uiSchemaApp, setUiDataApp]: any = useState({});
  const [jsonSchemaAdv, setJsonDataAdv]: any = useState({});
  const [uiSchemaAdv, setUiDataAdv]: any = useState({});
  const [formDataPkg, setFormDataPkg]: any = useState({});
  const [formDataApp, setFormDataApp]: any = useState({});
  const [formDataAdv, setFormDataAdv]: any = useState({});
  const [status, setStatus] = useState(false);
  const [IDX, setIDX]: any = useState(null);
  const [deviceSearchVal, setDeviceSearchVal] = useState("");
  const [isOverlayFilter, setIsOverlayFilter] = useState(false);
  const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
  const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
  const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
  const [overlayFilterArray, setOverlayFilterArray] = useState<string[]>([]);
  const [isOverResetDisabled, setOverResetDisabled] = useState(true);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [uniqueScope, setUniqueScope] = useState<string[]>([]);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [exportDetails, setExportDetails] = useState<any[]>([]);
  const [isProgressLoading, setProgressLoading] = useState(false);
  const [isOverlayProgressLoading, setOverlayProgressLoading] = useState(false);
  const [overlayExportBtnClicked, setOverlayExportBtnClicked] = useState(false);
  const [overlayExportDetails, setOverlayExportDetails] = useState<any[]>([]);
  const [exportOverlayStatusData, setExportOverlayStatusData] = useState([]);
  const [totalOverlayPages, setTotalOverlayPages] = useState(1);
  const [currentOverlayPageNo, setCurrentOverlayPageNo] = useState(1);
  const [totalOverlayRecords, setTotalOverlayRecords] = useState(0);
  const pageName = "Software Distribution";

  const handleOverlayFilter = (): any => {
    const value1 = dropDownValue1Overlay;
    const value2 = dropDownValue2Overlay;
    const result = value1 + " : " + value2;
    setOverlayFilterArray([...overlayFilterArray, result])
    setIsFilter(true);
    setIsOverlayFilter(true);
    // setLoading(true);
    setDropDownValue1Overlay('');
    setDropDownValue2Overlay('');
  }

  const handleCloseOverlayFilter = (index: any): any => {
    console.log(" handleCloseOverlayFilter clicked");
    const updatedArray = overlayFilterArray.filter((x, itemIndex) => itemIndex !== index);
    setOverlayFilterArray(updatedArray);
    // setLoadingTable(true);
    setIsOverlayFilter(false);
  }

  const overlayInputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9 ]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1Overlay === ("Device Name") || dropDownValue1Overlay === ("Solution Status")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }

    if (name === 'filter' && dropDownValue1Overlay === ("Executed Time")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }
  }

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    if (name === 'filter') {
      setDropDownValue2(enteredValue);
    }
  }
  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  }

  const handleCloseFilter = (index: any): any => {
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  useEffect(() => {
    if (filterArray?.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  useEffect(() => {
    if (overlayFilterArray?.length > 0) {
      setOverResetDisabled(false)
    } else {
      setOverResetDisabled(true)
    }
  }, [overlayFilterArray])

  // //data table column name code starts here
  // var columns = [
  //   { key: "JobCreatedTime", label: <Body1Strong> Date (UTC) </Body1Strong> },
  //   { key: "JobCreatedTime_timezoned", label: <Body1Strong> Date ({formattedTimeZone}) </Body1Strong> },
  //   { key: "ProfileName", label: <Body1Strong> Solution </Body1Strong> },
  //   //{ key: "SelectionType", label: <Body1Strong> Description </Body1Strong> },
  //   { key: "MachineTag", label: <Body1Strong> Scope </Body1Strong> },
  //   { key: "AgentUniqId", label: <Body1Strong> Initiated by </Body1Strong> },
  //   // { key: "JobStatus", label: <Body1Strong> Status </Body1Strong> },
  // ];
  // //data table column name code ends here

  // //data table for filter starts here
  // var columns1 = [
  //   { key: "JobCreatedTime", label: <Caption1> Date </Caption1> },
  //   { key: "ProfileName", label: <Caption1> Solution </Caption1> },
  //   // { key: "SelectionType", label: <Caption1> Description </Caption1> },
  //   { key: "MachineTag", label: <Caption1> Scope </Caption1> },
  //   { key: "AgentUniqId", label: <Caption1> Initiated by </Caption1> },
  //   { key: "JobStatus", label: <Caption1> Status </Caption1> },
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.apps?.Status.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "JobCreatedTime_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.apps?.Status.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "apps", page: "Status" });
  }, [contextValue.tableColumnsData]);

  //overlay datatable code start here
  var overlayColumns = [
    { key: "dname", label: <Body1Strong>Device Name</Body1Strong> },
    { key: "status", label: <Body1Strong>Solution Status</Body1Strong> },
    { key: "exetime", label: <Body1Strong>Executed Time</Body1Strong> },
  ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        <StackItem>
          {
            permissions.includes("all") || permissions.includes("status_Fullaccess") || permissions.includes("status_ReadandExport") ?
              <StackItem>
                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_statuslist.csv`}>
                </CSVLink>
                <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); setProgressLoading(true); }}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                  </Stack>
                </Button>
              </StackItem>
              :
              <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                <Button shape="circular" appearance="subtle" size="small" disabled>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                        <StackItem><Caption1> Export </Caption1></StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Button>
              </Tooltip>
          }
        </StackItem>

        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here

  var timer: any;
  const searchHandle = (data: any) => {
    timer = clearTimeout(timer);

    timer = setTimeout(() => {
      setSearchVal(data.target.value);
      setCurrentPageNo(1);
    }, 1500);
  };

  const handleEditData = (data: any) => {
    const pkgDetails = JSON.parse(data.softinst_PackagesConfiguration_form[0].formDataPkg)
    const appDetail = JSON.parse(data.softinst_PackagesConfiguration_form[0].formDataApp)
    const advDetail = JSON.parse(data.softinst_PackagesConfiguration_form[0].formDataAdv)
    setFormDataPkg(pkgDetails)
    setFormDataApp(appDetail);
    setFormDataAdv(advDetail);
  }

  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];
  var tempStatusExport: any = [];
  var message: any;

  //main table data push, currently pushing data without any filter or condition
  useEffect(() => {
    if (final_data !== undefined && final_data !== null) {
      const newUniqueScope: string[] = [];

      final_data.forEach((val: any) => {
        const WordSelectionType = val.SelectionType.split(':')[0];
        // if (val.initiatedBy && val.initiatedBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.initiatedBy)) {
        //     newUniqueCreatedBy.push(val.initiatedBy);
        // }
        if (val.pageName && val.pageName.trim() !== "-" && !newUniqueScope.includes(val.pageName)) {
          newUniqueScope.push(val.pageName);
        }
      });
      // Set the unique values for each filter category
      setUniqueScope(newUniqueScope);
    } else {
      setUniqueScope([]);
    }
  }, [final_data])

  useEffect(() => {
    console.log("final_data=", final_data);
    const uniqueTimes = new Set();
    let filterdata = final_data !== undefined && final_data !== null && final_data.filter((entry: any) => {
      if (!uniqueTimes.has(entry.ProfileName)) {
        uniqueTimes.add(entry.ProfileName);
        return true;
      }
      return false;
    })
    console.log("filterdataaa=====  ", filterdata);
    final_data !== undefined && final_data !== null
      ? final_data.map((val: any, i: any) => {
        const profilename = val.ProfileName.includes("SWD : ") ? val.ProfileName.split("SWD : ")[1] : val.ProfileName;
        const WordSelectionType = val.SelectionType.split(':')[0];
        console.log('IDX :', val.IDX)
        // menuLists.push();
        tempTableData.push({
          checkbox: "hide",
          JobCreatedTime: {
            label:
              <Button id="ButtonHover" appearance="transparent" size="small" onClick={() => { setIDX(val.IDX); setOverlayOpen(true); setselectedActivity({ name: profilename, time: val.JobCreatedTime, initiated: (val.AgentName !== null && val.AgentName !== undefined && val.AgentName?.length > 0) ? val.AgentName : '-', IDX: val.IDX }) }}>
                {convertUTCToReadableFormat(val.JobCreatedTime)}
              </Button>, id: `${i}`
          },
          JobCreatedTime_timezoned: {
            label:
              <Button id="ButtonHover" appearance="transparent" size="small" onClick={() => { setIDX(val.IDX); setOverlayOpen(true); setselectedActivity({ name: profilename, time: val.JobCreatedTime, initiated: (val.AgentName !== null && val.AgentName !== undefined && val.AgentName?.length > 0) ? val.AgentName : '-', IDX: val.IDX }) }}>
                {convertToLocalTimezone(val.JobCreatedTime, userTimeZone)}
              </Button>, id: `${i}`
          },
          ProfileName: { label: <Caption1> {profilename} </Caption1>, status: "" },
          MachineTag: {
            label: <Caption1> {WordSelectionType == ' All Devices' ? (
              <span> All Devices </span>
            ) : WordSelectionType == ' Machine' || WordSelectionType === '' ? (
              <span> Machine</span>
            ) : (
              <span> {WordSelectionType} </span>
            )}</Caption1>
          },
          AgentUniqId: { label: <Caption1> {(val.AgentUniqId !== null && val.AgentUniqId !== undefined && val.AgentUniqId?.length > 0) ? val.AgentUniqId : '-'} </Caption1>, icon: "", status: "" },
          JobStatus: { label: <Caption1>{message} </Caption1> },


        })

      }) : (tempTableData = []);
    console.log("tempTableData=", tempTableData);
    tempTableData?.length > 0 ? setTableData(tempTableData) : setTableData([]);
    console.log("tabledata before ->  ", tableData)
    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, permissions]);
  // useEffect(() => {


  var tempExportData: any = [];
  var tempStatusExport: any = [];
  var message: any;

  useEffect(() => {
    const tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      const WordSelectionType = val.SelectionType.split(':')[0].trim();
      console.log('WordSelectionType: ', WordSelectionType)
      let Scope = WordSelectionType === 'All Devices' ? 'All Devices' : WordSelectionType === 'Machine' || WordSelectionType === '' ? (
        "Machine"
      ) : (
        "WordSelectionType"
      )

      tempExportData.push({
        "Job Created Time": val.JobCreatedTime ? convertToExcelFormat(val.JobCreatedTime) : " -",
        "SelectionType": Scope ? Scope : " -",
        "ProfileName": val.ProfileName.includes("SWD : ") ? val.ProfileName.split("SWD : ")[1] : val.ProfileName,
        "Initiated By": val.AgentUniqId ? val.AgentUniqId : " -",
      });
    });

    tempExportData?.length > 0 && setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData?.length > 0 && document.getElementById('csv-export-link')?.click();
    setProgressLoading(false);
  }, [exportData]);

  // data table values append code ends here

  useEffect(() => {
    // Overlay activity status values append code starts here
    console.log("final_data status overlay--------", final_data2);

    final_data2 !== undefined && final_data2 !== null
      ? final_data2 && final_data2.map((actVal: any, i: any) => {
        console.log('final_data2 = ', final_data2)
        setAutomationName(actVal.Packages?.packageName);
        setCreatedBy(actVal.Packages?.createdBy);
        // const dataObject = JSON.parse(actVal.jsonValue);
        // setJsonValue(dataObject);

        if (actVal?.length > 0) {
          const data = actVal
          const uniqueData = Array.from(new Set(data.map((item: any) => item.AgentUniqId))).map(agentId => {
            return data.find((item: any) => item.AgentUniqId === agentId);
          });

          setAutomationJsonAuditData(uniqueData);
        } else {
          console.log("it's empty");
          setAutomationJsonAuditData([]);
        }

      }) : (console.log("null"));
  }, [final_data2, selectedActivity, searchTargetVal]);

  useEffect(() => {
    var tempOverlayExportData: any = [];

    overlayExportDetails?.length > 0 && overlayExportDetails.map((val: any) => {
      const WordSelectionType = val.SelectionType.split(':')[0].trim();
      console.log('WordSelectionType: ', WordSelectionType)
      let Scope = WordSelectionType === 'All Devices' ? 'All Devices' : WordSelectionType === 'Machine' || WordSelectionType === '' ? (
        "Machine"
      ) : (
        "WordSelectionType"
      )

      const statusdata = val.JobStatus;
      if (statusdata === 0) {
        message = 'Pending';
      } else if (statusdata === 2) {
        message = 'Success';
      } else if (statusdata === 3) {
        message = 'Failed';
      } else {
        message = 'Failed';
      }

      tempOverlayExportData.push({
        "Device Name": val.MachineTag ? val.MachineTag : " -",
        "Solution Status": statusdata ? statusdata : " -",
        "Executed Time": val.ClientExecutedTime ? convertToExcelFormat(val.ClientExecutedTime) : " -",
      });
    });

    setExportOverlayStatusData(tempOverlayExportData);
  }, [overlayExportDetails]);

  useEffect(() => {
    exportOverlayStatusData?.length > 0 && document.getElementById('csv-export-link-overlay')?.click();
    setOverlayProgressLoading(false);
  }, [exportOverlayStatusData]);

  useEffect(() => {
    // Overlay data table values append code starts here
    console.log("Status final_Targetdata ---------->", final_Targetdata);


    final_Targetdata !== undefined && final_Targetdata !== null
      ? final_Targetdata.map((val: any, i: any) => {
        console.log('final_Targetdata = ' + val)
        const deviceData = val;
        // let auditData = deviceData && deviceData.map((data: any, i: any) => {
        //   return data;
        // })

        // if (auditData) {
        //   auditData.forEach((data: any, i: any) => {
        console.log('data=============-->', val)
        const statusdata = val.JobStatus;
        if (statusdata === 0) {
          message = 'Pending';
        } else if (statusdata === 2) {
          message = 'Success';
        } else if (statusdata === 3) {
          message = 'Failed';
        } else {
          message = 'Failed';
        }
        tempStatusExport.push({
          DeviceName: val.MachineTag,
          SolutionStatus: message,
          ExecutedTime: val.ClientExecutedTime != null ? convertToExcelFormat(val.ClientExecutedTime) : '-',
        });

        tempTableData.push({
          id: val.MachineTag,
          checkbox: "hide",
          dname: { label: <Caption1> {val.MachineTag}  </Caption1>, icon: "", id: `${i}` },
          status: { label: <Caption1> {message} </Caption1>, icon: "", status: "" },
          exetime: {
            label: <Caption1> {val.ClientExecutedTime != null ? convertUTCToReadableFormat(val.ClientExecutedTime) : '-'} </Caption1>, icon: ""
          }
        });
        //   });
        // }

      }) : (tempTableData = []);
    setExportStatusData(tempStatusExport);

    tempTableData?.length > 0 ? setTableData1(tempTableData) : setTableData1([]);
    setTimeout(() => {
      final_Targetdata !== undefined && final_Targetdata !== null && setLoadingTable(false);
    }, 500);
  }, [final_Targetdata, selectedActivity]);



  //Solu details
  // useEffect(() => {
  //   let automationSequencesArray: any = [];
  //   let automationWithoutConditionIds: any = [];
  //   console.log('Selected Activity final_Targetdata:', final_Targetdata);

  //   if (final_Targetdata !== undefined && final_Targetdata !== null && final_Targetdata.automationWithCondition) {
  //     final_Targetdata.automationWithCondition.forEach((val: any, i: any) => {

  //       const jsonData = val && val.jsonValue;
  //       const parsedData = JSON.parse(jsonData);
  //       const automationSequence = parsedData.automation_sequence;

  //       automationSequencesArray.push(automationSequence);
  //     });
  //   } else {
  //     console.log(null);
  //   }

  //   if (final_Targetdata !== undefined && final_Targetdata !== null && final_Targetdata.automationWithoutCondition) {
  //     automationWithoutConditionIds = final_Targetdata.automationWithoutCondition.map((val: any) => {
  //       return {
  //         automationName: val.automationName,
  //         id: val.id,
  //       };
  //     });
  //   } else {
  //     console.log(null);
  //   }
  //   console.log("Automation Sequences Array:", automationSequencesArray);
  //   // console.log("Automation Without Condition IDs:", automationWithoutConditionIds);

  //   const uniqueIds = new Set();
  //   if (automationSequencesArray.length > 0) {
  //     let sequenceIds = automationSequencesArray[0]?.split(',').map((id: any) => parseInt(id.trim()));

  //     //console.log("sequenceIds************", sequenceIds);

  //     let matchingAutomations = automationWithoutConditionIds.filter((automation: any) => sequenceIds?.includes(automation.id));

  //     const automationNames = matchingAutomations.map((data: any) => data.automationName);

  //     const uniqeAutoName = new Set(automationNames);
  //     const uniqueAutoNames = [...(uniqeAutoName as unknown as any[])];
  //     //console.log("Each automationNames*****************", uniqueAutoNames);
  //     setUniqueAutomationNames(uniqueAutoNames);

  //   } else {
  //     console.log("automationSequencesArray is empty");
  //   }

  // }, [final_Targetdata, selectedActivity]);






  //overlay code starts here
  var overLayData: any = {
    headerTitle: (
      <>
        <Stack>
          <FluentProvider theme={dashboardTheme}>
            <Title3>App Status Details</Title3>
          </FluentProvider>
        </Stack>
      </>
    ),
    size: 'large',
    isTabs: true,
    tabItems: {
      Activity: (
        <Stack>
          <Stack tokens={{ childrenGap: 10 }}>
            <StackItem>
              <Text></Text>
            </StackItem>
            <StackItem>
              <Text></Text>
            </StackItem>
            {selectedActivity.name ? (
              <>
                <StackItem>
                  <Subtitle2Stronger>Package Name: </Subtitle2Stronger>
                  {selectedActivity.name}
                </StackItem>
                <StackItem>
                  <Subtitle2Stronger>Initiated by: </Subtitle2Stronger>
                  {selectedActivity.initiated}
                </StackItem>
                <StackItem>
                  <Subtitle2Stronger>Created on: </Subtitle2Stronger> {convertUTCToReadableFormat(selectedActivity.time)}
                </StackItem>
              </>
            ) : (
              ' No result! '
            )}

            {automationJsonAuditData && automationJsonAuditData?.length > 0 && (
              <>
                <StackItem>
                  {' '}
                  <Subtitle2Stronger> Solution name : </Subtitle2Stronger> {jsonValue.automation_name}{' '}
                </StackItem>
                <StackItem>
                  {' '}
                  <Subtitle2Stronger> Solution description : </Subtitle2Stronger> {jsonValue.description}{' '}
                </StackItem>
                <StackItem>
                  {' '}
                  <Subtitle2Stronger> Category Name : </Subtitle2Stronger> {jsonValue.category}{' '}
                </StackItem>
                <StackItem>
                  {' '}
                  <Subtitle2Stronger> Category description : </Subtitle2Stronger> {jsonValue.category_description}{' '}
                </StackItem>
                <StackItem>
                  {' '}
                  <Subtitle2Stronger> Sub Category Name : </Subtitle2Stronger>
                  {jsonValue.sub_category}{' '}
                </StackItem>
                <StackItem>
                  {' '}
                  <Subtitle2Stronger>Sub Category description : </Subtitle2Stronger> {jsonValue.sub_category_description}{' '}
                </StackItem>
              </>
            )}
            <StackItem>
              <Stack tokens={{ childrenGap: 10 }}>
                {automationJsonAuditData.map((data: any, inx: any) => {
                  const WordSelectionType = data.SelectionType.split(' ')[0];

                  return (
                    <>
                      <Stack tokens={{ childrenGap: 10 }}>
                        <StackItem>
                          <Subtitle2Stronger>Job Created Time: </Subtitle2Stronger>
                          {convertUTCToReadableFormat(data.JobCreatedTime)}
                        </StackItem>

                        <StackItem>
                          <Subtitle2Stronger>Scope:</Subtitle2Stronger>
                          {WordSelectionType === 'Site' ? (
                            <span> All Devices </span>
                          ) : WordSelectionType === 'Machine' ? (
                            <span> Machine</span>
                          ) : (
                            <span> Device Classification </span>
                          )}
                        </StackItem>

                        <StackItem>
                          {' '}
                          <Subtitle2Stronger>Agent Id:</Subtitle2Stronger> {data.AgentUniqId}
                        </StackItem>

                        <StackItem>
                          {' '}
                          <Subtitle2Stronger>Agent Name:</Subtitle2Stronger> {data.AgentName?.length > 0 ? data.AgentName : '-'}
                        </StackItem>
                      </Stack>
                    </>
                  );
                })}
              </Stack>
            </StackItem>
          </Stack>
        </Stack>
      ),
      Targets: (
        <Stack tokens={{ childrenGap: 15 }} style={DynamicBoxingCSS}>
          {/* <InfoBar showSpaces={true} title={"Try changing or adding filters if you don't see what you're looking for."} /> */}
          <StackItem>
            <Stack wrap horizontal tokens={{ childrenGap: 20, padding: '0px 0px 5px 0px' }}>
              <SearchBar columnSearch={'for Device Name'} searchVal={deviceSearchVal} setSearchVal={setDeviceSearchVal} disabled={loadingTable || tableData1.length === 0}/>
              {/* <SearchBox onChange={(e: any) => { setSearchDevVal(e.target.value); }} placeholder="Search" size="small" /> */}
              <StackItem>
                <MenuDropdown
                  open={filterMenuOpenOverlay}
                  btn={
                    <MenuButton disabled={loadingTable || tableData1.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <FilterAdd20Filled {...primaryIcon} />
                        <Body1> Filter </Body1>
                      </Stack>
                    </MenuButton>
                  }
                  itemVal={
                    <>
                      <Body1Strong> Add a Filter </Body1Strong>
                      <Divider />
                      <MenuList>
                        <Stack tokens={{ childrenGap: 5 }}>
                          <StackItem>
                            {' '}
                            <Text></Text>{' '}
                          </StackItem>
                          <StackItem>
                            {' '}
                            <Caption1> Filter </Caption1>{' '}
                          </StackItem>
                          <DropdownComponent
                            optionData={overlayColumns}
                            setDropDownValue={setDropDownValue1Overlay}
                            dropDownvalue={dropDownValue1Overlay}
                          />
                          <StackItem>
                            {' '}
                            <Divider />{' '}
                          </StackItem>
                          <StackItem>
                            {' '}
                            <Caption1> Value </Caption1>{' '}
                          </StackItem>
                          {(dropDownValue1Overlay === 'Device Name' ||
                            dropDownValue1Overlay === 'Solution Status' ||
                            dropDownValue1Overlay === 'Executed Time') && (
                              <Input size="small" onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />
                            )}
                          <StackItem>
                            <Divider />
                          </StackItem>
                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem>
                              <Button shape="circular"
                                appearance="primary"
                                onClick={() => {
                                  handleOverlayFilter();
                                  setFilterMenuOpenOverlay(false);
                                }}
                                disabled={
                                  !dropDownValue1Overlay || !dropDownValue2Overlay || overlayFilterArray.includes(`${dropDownValue1Overlay}:`)
                                }
                              >
                                <Caption1> Apply </Caption1>
                              </Button>
                            </StackItem>
                            <StackItem>
                              <Button shape="circular" onClick={() => { setFilterMenuOpenOverlay(false); setIsOverlayFilter(false); setDropDownValue1Overlay(''); setDropDownValue2Overlay(''); }}> <Caption1> Cancel </Caption1>
                              </Button>
                            </StackItem>
                          </Stack>
                        </Stack>
                      </MenuList>
                    </>
                  }
                />
              </StackItem>

              <StackItem
                onClick={() => {
                  setOverlayFilterArray([]);
                  setIsFilter(false);
                  setDropDownValue2('');
                  setOverResetDisabled(true);
                }}
              >
                <Button shape="circular" appearance="subtle" size="small" disabled={isOverResetDisabled}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>
                      {' '}
                      <FilterDismiss20Filled />{' '}
                    </StackItem>
                    <StackItem>
                      {' '}
                      <Caption1> Reset Filters </Caption1>{' '}
                    </StackItem>
                  </Stack>
                </Button>
              </StackItem>
              <StackItem>
                {permissions.includes('all') || permissions.includes('status_Fullaccess') || permissions.includes('status_ReadandExport') ? (
                  <StackItem>
                    <CSVLink id="csv-export-link-overlay" data={exportOverlayStatusData} filename={`${tenantName}_statusactivitylist.csv`}></CSVLink>
                    <Button shape="circular"
                      appearance="subtle"
                      size="small"
                      onClick={() => {
                        setOverlayExportBtnClicked(true);
                        setOverlayProgressLoading(true);
                      }}
                      disabled={final_data2?.length === 0 ? true : false}
                    >
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem>
                          {' '}
                          <ArrowDownload20Regular {...primaryIcon} />{' '}
                        </StackItem>
                        <StackItem>
                          {' '}
                          <Caption1> Export </Caption1>{' '}
                        </StackItem>
                      </Stack>
                    </Button>
                  </StackItem>
                ) : (
                  <Tooltip withArrow content={'You do not have access'} relationship="description" positioning="above">
                    <Button shape="circular" appearance="subtle" size="small" disabled>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem>
                          <Text></Text>
                        </StackItem>
                        <StackItem>
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>
                              {' '}
                              <ArrowDownload20Regular {...secondaryIcon} />{' '}
                            </StackItem>
                            <StackItem>
                              <Caption1> Export </Caption1>
                            </StackItem>
                          </Stack>
                        </StackItem>
                      </Stack>
                    </Button>
                  </Tooltip>
                )}
              </StackItem>

              {final_Targetdata?.length > 0 && !loadingTable && (
                <Stack horizontal enableScopedSelectors horizontalAlign="space-between">

                  <StackItem>
                    {' '}
                    <Pagination
                      setLoading={setLoadingTable}
                      totalPages={totalOverlayPages}
                      currentPageNo={currentOverlayPageNo}
                      setCurrentPageNo={setCurrentOverlayPageNo}
                    />{' '}
                  </StackItem>
                </Stack>
              )}
            </Stack>
            <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
              <StackItem>
                {overlayFilterArray.length > 0 &&
                  // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                  <Stack wrap horizontal >
                    {overlayFilterArray?.length > 0 && overlayFilterArray.map((item, index) => (
                      <Button shape="circular" size="small">
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                          <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                          <StackItem>
                            <Stack tokens={{ childrenGap: 1 }}>
                              <StackItem><Text></Text></StackItem>
                              <StackItem><Dismiss16Regular onClick={() => { handleCloseOverlayFilter(index) }} /></StackItem>
                            </Stack>
                          </StackItem>
                        </Stack>
                      </Button>
                    ))}
                    {/* </Stack> */}
                  </Stack>}
              </StackItem>

              <StackItem disableShrink>
                {' '}
                {totalOverlayRecords > 0 && (
                  <Caption1>
                    {' '}
                    Showing {(currentOverlayPageNo - 1) * 50 + 1} to{' '}
                    {currentOverlayPageNo * 50 > totalOverlayRecords ? totalOverlayRecords : currentOverlayPageNo * 50} of {totalOverlayRecords}{' '}
                    Records{' '}
                  </Caption1>
                )}{' '}
              </StackItem>
            </Stack>

          </StackItem>
          <StackItem style={DynamicBoxingCSS}>
            {loadingTable ? (
              <SkeletonOverlayDataTable />
            ) : tableData1?.length > 0 ? (
              <DataTable tableData={tableData1} columns={overlayColumns} />
            ) : (
              <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
                <StackItem>
                  <Text size={500}>No result.</Text>
                </StackItem>
              </Stack>
            )}
          </StackItem>

          {/* Device Pushed List
          { } */}
        </Stack>
      ),
      // "Solution Details":
      //   <Stack>
      //     {/* HI */}

      //     <Stack tokens={{ childrenGap: 10, padding: 10 }}>
      //       <Stack tokens={{ childrenGap: 10, padding: 10 }}>
      //         <StackItem><Text>
      //           <Subtitle2Stronger>
      //             Below are the automation sequence executed,
      //           </Subtitle2Stronger></Text></StackItem>
      //         <StackItem><Text></Text></StackItem>
      //         {uniqueAutomationNames.map((name, index) => (
      //           <>
      //             <StackItem> <Text>&bull; {name} </Text> </StackItem>
      //             <StackItem> <Text> </Text> </StackItem>
      //           </>
      //         ))}
      //         <StackItem>
      //           <Stack tokens={{ padding: 5 }}>
      //             {/* <Text as = "h4" >Package Details</Text> */}
      //             <Body1Strong>Package Details</Body1Strong>
      //             <Form disabled={true} formData={formDataPkg} schema={jsonSchemaPkg} uiSchema={uiSchemaPkg} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataPkg(e.formData)} />
      //           </Stack>
      //           <Stack>
      //             {/* <Text>App Configurations</Text> */}
      //             <Body1Strong>App Configurations</Body1Strong>
      //             <Form disabled={true} formData={formDataApp} schema={jsonSchemaApp} uiSchema={uiSchemaApp} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataApp(e.formData)} />
      //           </Stack>
      //           {/* <Text>Advance Configurations</Text> */}
      //           <Body1Strong>Advance Configurations</Body1Strong>
      //           <Stack horizontal tokens={{ childrenGap: 157, padding: 5 }}>
      //             <Form disabled={true} formData={formDataAdv} schema={jsonSchemaAdv} uiSchema={uiSchemaAdv} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataAdv(e.formData)} />
      //           </Stack>
      //         </StackItem>
      //       </Stack>
      //     </Stack>

      //   </Stack>,
    },
  };
  //overlay code ends here

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
                      {name: "Manage", link: "/home" },
                      {name:"Apps", link:"/manage/apps/discoveredapps"},
                      {name:"Status", link:"#"},
                    ]} 
                  /> 
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>

              <Status_func filterArray={filterArray} data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} activityData={final_data2} activityFunc={set_final_data2} selectedAct={selectedActivity} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} final_Targetdata={final_Targetdata} set_final_Targetdata={set_final_Targetdata} searchTargetVal={searchTargetVal} setAutomationJsonData={setAutomationJsonData} automationIds={automationIds} isOverlayFilter={isOverlayFilter} dropDownValue1Overlay={dropDownValue1Overlay} setIsOverlayFilter={setIsOverlayFilter} dropDownValue2Overlay={dropDownValue2Overlay} deviceSearchVal={deviceSearchVal} overlayFilterArray={overlayFilterArray} overlayPageNo={(currentOverlayPageNo - 1) * 50} setTotalOverlayPages={setTotalOverlayPages} setTotalOverlayRecords={setTotalOverlayRecords} setExportDetails={setExportDetails} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} setOverlayExportDetails={setOverlayExportDetails} setOverlayExportBtnClicked={setOverlayExportBtnClicked} overlayExportBtnClicked={overlayExportBtnClicked} jobType={pageName}
                setJsonDataPkg={setJsonDataPkg}
                setUiDataPkg={setUiDataPkg}
                setJsonDataApp={setJsonDataApp}
                setUiDataApp={setUiDataApp}
                setJsonDataAdv={setJsonDataAdv}
                setUiDataAdv={setUiDataAdv}
                formDataPkg={formDataPkg}
                formDataApp={formDataApp}
                formDataAdv={formDataAdv}
                setFormDataPkg={setFormDataPkg}
                setFormDataApp={setFormDataApp}
                setFormDataAdv={setFormDataAdv}
                handleEditData={handleEditData}
                status={status}
                setStatus={setStatus}
                IDX={IDX}
              />

              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={ManageAppPages("Status")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} className={isProgressLoading ? 'disabled-opacity' : ''} verticalAlign="center" tokens={{ childrenGap: 10 }}>
                      <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                        <StackItem>
                          <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                          <Stack>{isProgressLoading && <ProgressBar />}</Stack>
                          <Divider />
                        </StackItem>
                        <StackItem>
                          <StackItem style={wraperStyle}>
                            <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                              <Stack horizontal tokens={{ childrenGap: 10 }}>
                              <StackItem>
                                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Solution"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                </StackItem>
                                <StackItem>
                                  <MenuDropdown open={filterMenuOpen} btn={
                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                    <Divider />
                                    <MenuList>
                                      <Stack tokens={{ childrenGap: 5 }}>
                                        <StackItem> <Text></Text> </StackItem>
                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                        <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                        <StackItem> <Divider /> </StackItem>
                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                        {dropDownValue1 === 'Date' ? <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} /> : <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                        <StackItem> <Divider /> </StackItem>
                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                          <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                          <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                        </Stack>
                                      </Stack>
                                    </MenuList>
                                  </>} />
                                </StackItem>
                                <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true); }}>
                                  <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> <FilterDismiss20Filled /> </StackItem>
                                      <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                    </Stack>
                                  </Button>
                                </StackItem>
                              </Stack>
                              {tableData?.length > 0 && !loading && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                            </Stack>
                            {filterArray?.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                              <Stack wrap horizontal >
                                {filterArray?.length > 0 && filterArray.map((item, index) => (
                                  <Button shape="circular" size="small">
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                      <StackItem>
                                        <Stack tokens={{ childrenGap: 1 }}>
                                          <StackItem><Text></Text></StackItem>
                                          <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                        </Stack>
                                      </StackItem>
                                    </Stack>
                                  </Button>
                                ))}
                              </Stack>
                            </Stack>}
                          </StackItem>
                          <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          {tableData?.length > 0 && !loading && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                            <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                          </Stack>}
                        </StackItem>
                        {loading ? (<SkeletonDataTable />) : tableData?.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

                        {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                      </Stack>
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={overLayData}
            // isNavBtn={true}
            />
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};
